"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _mapInstanceProperty2 = require("@babel/runtime-corejs3/core-js/instance/map");

var _filterInstanceProperty2 = require("@babel/runtime-corejs3/core-js/instance/filter");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.mapToAction = exports.getExecutingState = exports.getLoadableErrorState = exports.addLoadingFailedReducer = exports.getLoadableLoadingState = exports.geChildCollectionLoadingState = exports.addChildCollectionLoadingReducer = exports.addChildCollectionFailedReducer = exports.getChildCollectionErrorState = exports.getChildCollectionSuccessState = exports.getLoadableSuccessState = exports.getSuccessState = exports.addLoadingReducer = exports.addChildCollectionSuccessReducer = exports.addLoadingSuccessReducer = exports.addSuccessReducer = exports.addAjaxEpic = exports.createAjaxEpic = exports.createSimpleEpic = exports.toActionFromPayload = exports.getFailureActionType = exports.getSuccessActionType = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _objectSpread10 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/parse-int"));

var _getOwnPropertyNames = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/object/get-own-property-names"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/map"));

var _map2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/map"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/filter"));

var _reduxObservable = require("redux-observable");

var _operators = require("rxjs/operators");

var _ILoading = require("../models/ILoading");

var _notificationsMerge = require("../Notifications/helpers/notificationsMerge");

var _redux = require("../Notifications/redux");

var _observableErrorHandler = require("./observableErrorHandler");

var _overrideSettings = require("../shared/override-settings/overrideSettings");

var getSuccessActionType = function getSuccessActionType(type) {
  return type + '/success';
};

exports.getSuccessActionType = getSuccessActionType;

var getFailureActionType = function getFailureActionType(type) {
  return type + '/failed';
};

exports.getFailureActionType = getFailureActionType;

var toActionFromPayload = function toActionFromPayload(type) {
  return function (payload) {
    return {
      type: type,
      payload: payload
    };
  };
}; // eslint-disable-next-line @typescript-eslint/no-explicit-any


exports.toActionFromPayload = toActionFromPayload;

var createSimpleEpic = function createSimpleEpic(type, actionHandler) {
  return function (action$, store, _ref) {
    var ajax = _ref.ajax;
    return action$.ofType(type).pipe((0, _operators.mergeMap)(function (action) {
      return actionHandler(ajax, action, store);
    }));
  };
};

exports.createSimpleEpic = createSimpleEpic;

var createAjaxEpic = function createAjaxEpic(type, ajaxHandler, successTypeOverride, failureTypeOverride, options) {
  return function (action$, store, _ref2) {
    var ajax = _ref2.ajax;
    options = options || {};
    var actionTypes = action$.ofType(type);
    var filterFn = (0, _filter.default)(options);

    if (filterFn) {
      actionTypes = actionTypes.pipe((0, _filterInstanceProperty2(_operators))(function (action) {
        return filterFn(action, store.getState());
      }));
    }

    var errorMessages = options.errorMessages;
    var mappedErrorMessages;

    if (errorMessages) {
      var _context;

      // Convert from object to map
      mappedErrorMessages = options.errorMessages ? new _map2.default((0, _map.default)(_context = (0, _getOwnPropertyNames.default)(options.errorMessages)).call(_context, function (statusCode) {
        var code = (0, _parseInt2.default)(statusCode, 10);
        return [code, errorMessages[code]];
      })) : undefined;
    }

    if (options.debounceTime) {
      actionTypes = actionTypes.pipe((0, _operators.debounceTime)(options.debounceTime));
    }

    return actionTypes.pipe((0, _operators.mergeMap)(function (action) {
      try {
        var actionObservable = ajaxHandler(ajax, action, store.getState());
        return mapToAction(actionObservable, action, successTypeOverride, failureTypeOverride, mappedErrorMessages);
      } catch (error) {
        return _reduxObservable.ActionsObservable.of({
          type: getFailureActionType(type),
          payload: error,
          meta: {
            parent: action
          } // eslint-disable-next-line @typescript-eslint/no-explicit-any

        });
      }
    }));
  };
};

exports.createAjaxEpic = createAjaxEpic;

var addAjaxEpic = function addAjaxEpic(registry, type, ajaxHandler, options) {
  options = options || {};
  var successType = options.successTypeOverride || getSuccessActionType(type);
  var failureType = options.failureTypeOverride || getFailureActionType(type);
  var epic = registry.addEpic(options.epicKey || type, createAjaxEpic(type, ajaxHandler, successType, failureType, options));

  if (options.statePropertyName) {
    if (options.isLoadable !== false) {
      if (options.addLoadingReducer !== false) {
        if (options.isChildCollection) {
          addChildCollectionLoadingReducer(registry, type, options.statePropertyName);
        } else {
          addLoadingReducer(registry, type, options.statePropertyName);
        }
      }

      if (options.addLoadingSuccessReducer !== false) {
        if (options.isChildCollection) {
          addChildCollectionSuccessReducer(registry, successType, options.statePropertyName, options.isPageable, options.loadingSuccessReducer);
        } else {
          addLoadingSuccessReducer(registry, successType, options.statePropertyName, options.isPageable, options.loadingSuccessReducer, options.successMessage);
        }
      }

      if (options.addLoadingFailedReducer !== false) {
        if (options.isChildCollection) {
          addChildCollectionFailedReducer(registry, failureType, options.statePropertyName, options.loadingFailedReducer);
        } else {
          addLoadingFailedReducer(registry, failureType, options.statePropertyName, options.loadingFailedReducer, options.showErrorAsToast);
        }
      }
    } else {
      addSuccessReducer(registry, successType, options.statePropertyName);
    }
  }

  var successMessage = options.successMessage;

  if (successMessage || options.showSuccessAsToast === true) {
    successMessage = successMessage || {
      key: 'The operation completed successfully'
    };

    if (!options.isChildCollection) {
      (0, _redux.addSuccessHandler)(successType, successMessage, registry);
    }
  }

  var errorMessage = options.errorMessage;

  if (errorMessage || options.showErrorAsToast !== false) {
    errorMessage = errorMessage || {
      key: 'An unexpected error has occurred'
    };

    if (!options.isChildCollection) {
      (0, _redux.addUnexpectedErrorHandler)(failureType, errorMessage, registry);
    }
  }

  return epic;
};

exports.addAjaxEpic = addAjaxEpic;

var addSuccessReducer = function addSuccessReducer(registry, successType, statePropertyName) {
  registry.add(successType, getSuccessState(statePropertyName));
};

exports.addSuccessReducer = addSuccessReducer;

var addLoadingSuccessReducer = function addLoadingSuccessReducer(registry, successType, statePropertyName, isPageable, loadingSuccessReducer, successMessage) {
  var baseReducer = getLoadableSuccessState(statePropertyName, isPageable, successMessage);
  var reducer;

  if (!loadingSuccessReducer) {
    reducer = baseReducer;
  } else {
    reducer = function reducer(state, action) {
      var nextState = baseReducer(state, action);
      var combinedState = loadingSuccessReducer(nextState, action);
      return combinedState;
    };
  }

  registry.add(successType, reducer);
};

exports.addLoadingSuccessReducer = addLoadingSuccessReducer;

var addChildCollectionSuccessReducer = function addChildCollectionSuccessReducer(registry, successType, statePropertyName, isPageable, loadingSuccessReducer) {
  var baseReducer = getChildCollectionSuccessState(statePropertyName, isPageable);
  var reducer;

  if (!loadingSuccessReducer) {
    reducer = baseReducer;
  } else {
    reducer = function reducer(state, action) {
      var nextState = baseReducer(state, action);
      var combinedState = loadingSuccessReducer(nextState, action);
      return combinedState;
    };
  }

  registry.add(successType, reducer);
};

exports.addChildCollectionSuccessReducer = addChildCollectionSuccessReducer;

var addLoadingReducer = function addLoadingReducer(registry, type, statePropertyName) {
  registry.add(type, getLoadableLoadingState(statePropertyName));
};

exports.addLoadingReducer = addLoadingReducer;

var getSuccessState = function getSuccessState(statePropertyName) {
  return function (state, action) {
    var payload = action.payload;

    if (payload === undefined) {
      return state;
    }

    return (0, _objectSpread10.default)((0, _objectSpread10.default)({}, state), {}, (0, _defineProperty2.default)({}, statePropertyName, payload));
  };
};

exports.getSuccessState = getSuccessState;

var getLoadableSuccessState = function getLoadableSuccessState(statePropertyName, isPageable, successMessage) {
  return function (state, action) {
    var payload = action.payload;

    if (payload === undefined) {
      return state;
    }

    var nextState = state;
    var value;

    if (!isPageable) {
      value = payload;
    } else {
      value = payload.value;
    }

    if (successMessage) {
      nextState = (0, _notificationsMerge.addNotification)(state, (0, _redux.success)(successMessage));
    }

    return (0, _objectSpread10.default)((0, _objectSpread10.default)({}, nextState), {}, (0, _defineProperty2.default)({}, statePropertyName, (0, _objectSpread10.default)((0, _objectSpread10.default)({}, state[statePropertyName]), {}, {
      value: value,
      isLoading: false,
      loadingState: _ILoading.LoadingState.loaded,
      loadingError: undefined
    })));
  };
};

exports.getLoadableSuccessState = getLoadableSuccessState;

var getChildCollectionSuccessState = function getChildCollectionSuccessState(statePropertyName, _isPageable) {
  return function (state, action) {
    var payload = action.payload;

    if (payload === undefined) {
      return state;
    }

    var currentMap = state[statePropertyName // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ];
    var nextValue = payload;
    var parentId = nextValue.parentId; // Create a writeable copy from read only map

    var updateMap = new _map2.default(currentMap);
    updateMap.set(parentId, {
      value: nextValue.value,
      nextLink: nextValue.nextLink,
      isLoading: false,
      loadingState: _ILoading.LoadingState.loaded,
      loadingError: undefined
    });
    return (0, _objectSpread10.default)((0, _objectSpread10.default)({}, state), {}, (0, _defineProperty2.default)({}, statePropertyName, updateMap));
  };
};

exports.getChildCollectionSuccessState = getChildCollectionSuccessState;

var getChildCollectionErrorState = function getChildCollectionErrorState(statePropertyName) {
  return function (state, action) {
    var payload = action.payload;

    if (payload === undefined) {
      return state;
    }

    var currentMap = state[statePropertyName // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ];
    var meta = action.meta;
    var parentPayload;

    if (meta) {
      var parent = meta.parent;

      if (parent) {
        parentPayload = parent.payload;
      }
    }

    var parentId = parentPayload;

    if (!parentId) {
      return state;
    }

    var currentChildCollection = currentMap.get(parentId) || {
      value: []
    }; // Create a writeable copy from read only map

    var updateMap = new _map2.default(currentMap);
    updateMap.set(parentId, {
      value: currentChildCollection.value,
      nextLink: currentChildCollection.nextLink,
      isLoading: false,
      loadingState: _ILoading.LoadingState.error,
      loadingError: action.payload // eslint-disable-next-line @typescript-eslint/no-explicit-any

    });
    return (0, _objectSpread10.default)((0, _objectSpread10.default)({}, state), {}, (0, _defineProperty2.default)({}, statePropertyName, updateMap));
  };
};

exports.getChildCollectionErrorState = getChildCollectionErrorState;

var addChildCollectionFailedReducer = function addChildCollectionFailedReducer(registry, failType, statePropertyName, loadingFailedReducer) {
  var baseReducer = getChildCollectionErrorState(statePropertyName);
  var reducer;

  if (!loadingFailedReducer) {
    reducer = baseReducer;
  } else {
    reducer = function reducer(state, action) {
      var nextState = baseReducer(state, action);
      var combinedState = loadingFailedReducer(nextState, action);
      return combinedState;
    };
  }

  registry.add(failType, reducer);
};

exports.addChildCollectionFailedReducer = addChildCollectionFailedReducer;

var addChildCollectionLoadingReducer = function addChildCollectionLoadingReducer(registry, type, statePropertyName) {
  registry.add(type, geChildCollectionLoadingState(statePropertyName));
};

exports.addChildCollectionLoadingReducer = addChildCollectionLoadingReducer;

var geChildCollectionLoadingState = function geChildCollectionLoadingState(statePropertyName) {
  return function (state, action) {
    var payload = action.payload;

    if (payload === undefined) {
      return state;
    }

    var currentMap = state[statePropertyName // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ];
    var parentId = action.payload;

    if (!parentId) {
      return state;
    }

    var currentChildCollection = currentMap.get(parentId) || {
      value: []
    }; // Create a writeable copy from read only map

    var updateMap = new _map2.default(currentMap);
    updateMap.set(parentId, {
      value: currentChildCollection.value,
      nextLink: currentChildCollection.nextLink,
      isLoading: true,
      loadingState: _ILoading.LoadingState.loading,
      loadingError: undefined,
      retryCount: 0 // TODO: Fully support
      // eslint-disable-next-line @typescript-eslint/no-explicit-any

    });
    return (0, _objectSpread10.default)((0, _objectSpread10.default)({}, state), {}, (0, _defineProperty2.default)({}, statePropertyName, updateMap));
  };
};

exports.geChildCollectionLoadingState = geChildCollectionLoadingState;

var getLoadableLoadingState = function getLoadableLoadingState(statePropertyName) {
  return function (state, action) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var currentValue = state[statePropertyName];
    return (0, _objectSpread10.default)((0, _objectSpread10.default)({}, state), {}, (0, _defineProperty2.default)({}, statePropertyName, (0, _objectSpread10.default)((0, _objectSpread10.default)({}, currentValue), {}, {
      isLoading: true,
      loadingState: _ILoading.LoadingState.loading,
      loadingError: undefined,
      retryCount: 0
    })));
  };
};

exports.getLoadableLoadingState = getLoadableLoadingState;

var addLoadingFailedReducer = function addLoadingFailedReducer(registry, failType, statePropertyName, loadingFailedReducer, showErrorAsToast) {
  var baseReducer = getLoadableErrorState(statePropertyName, showErrorAsToast);
  var reducer;

  if (!loadingFailedReducer) {
    reducer = baseReducer;
  } else {
    reducer = function reducer(state, action) {
      var nextState = baseReducer(state, action);
      var combinedState = loadingFailedReducer(nextState, action);
      return combinedState;
    };
  }

  registry.add(failType, reducer);
};

exports.addLoadingFailedReducer = addLoadingFailedReducer;

var logAjaxErrorResponse = function logAjaxErrorResponse(action) {
  var payload = action.payload;

  if (payload && payload.response && payload.response) {
    var telemetryEmitter = (0, _overrideSettings.getOverrideSetting)('telemetryImplementation');
    telemetryEmitter === null || telemetryEmitter === void 0 ? void 0 : telemetryEmitter.error('request/failed', {
      error: payload.response
    });
  }
};

var getLoadableErrorState = function getLoadableErrorState(statePropertyName, showErrorAsToast) {
  return function (state, action) {
    logAjaxErrorResponse(action);
    var currentValue = state[statePropertyName];
    return (0, _objectSpread10.default)((0, _objectSpread10.default)({}, state), {}, (0, _defineProperty2.default)({}, statePropertyName, (0, _objectSpread10.default)((0, _objectSpread10.default)({}, currentValue), {}, {
      isLoading: false,
      loadingState: !showErrorAsToast ? _ILoading.LoadingState.error : currentValue.loadingState,
      loadingError: !showErrorAsToast ? action.payload : undefined,
      retryCount: 0
    })));
  };
};

exports.getLoadableErrorState = getLoadableErrorState;

var getExecutingState = function getExecutingState(stateKey) {
  return function (state, action) {
    if (!action.payload) {
      return (0, _objectSpread10.default)({}, state);
    }

    var executingState = state[stateKey];
    var retryCount = executingState.retryCount || 0;
    return (0, _objectSpread10.default)((0, _objectSpread10.default)({}, state), {}, (0, _defineProperty2.default)({}, stateKey, (0, _objectSpread10.default)((0, _objectSpread10.default)({}, state[stateKey]), {}, {
      isExecuting: true,
      retryCount: action.payload.isRetrying ? retryCount + 1 : 0
    })));
  };
};

exports.getExecutingState = getExecutingState;

var mapToAction = function mapToAction(observable, action, successTypeOverride, failureTypeOverride, errorMessages) {
  var failureType = failureTypeOverride || getFailureActionType(action.type);
  var onSuccessHandler = toActionFromPayload(successTypeOverride || getSuccessActionType(action.type)); // TODO: This really should be ErrorFluxStandardAction

  var catchHandler = (0, _operators.catchError)((0, _observableErrorHandler.errorHandler)(failureType, action, {
    errorMessages: errorMessages
  }));
  return observable.pipe((0, _mapInstanceProperty2(_operators))(onSuccessHandler), catchHandler);
};

exports.mapToAction = mapToAction;